import React from 'react';
import { Switch, Route } from 'react-router-dom';

import List from './List';
import Form from './Form';

const Report: React.FC = () => {
  return (
    <Switch>
      <Route path="/reports" component={List} isPrivate exact />
      <Route path="/reports/add" component={Form} isPrivate />
      <Route path="/reports/edit/:id" component={Form} isPrivate />
    </Switch>
  );
};

export default Report;
